import React, { useCallback, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { IDocumentData } from '../../../interfaces/document';
import DocumentData from './DocumentData';
import DocumentRoStatus from './DocumentRoStatus';

interface IViewDataDialogProps extends React.AllHTMLAttributes<HTMLDivElement> {
	documentId: string;
	handleClose: () => void;
}
const ViewDataDialog = ({ documentId, handleClose }: IViewDataDialogProps) => {
	const [documentData, setDocumentData] = useState<IDocumentData | null>();

	const onDataFetched = useCallback((data: IDocumentData | null) => {
		setDocumentData(data);
	}, []);

	return (
		<Modal centered show size="xl" fullscreen="xl-down" onHide={handleClose}>
			<Modal.Header closeButton>
				<div className="flex-grow-1 d-flex gap-1 justify-content-between align-items-center min-width-0">
					<Modal.Title className="text-truncate">
						{documentData?.main.title || 'Інформація про дослідження'}
					</Modal.Title>
					{documentData && (
						<DocumentRoStatus status={documentData.main.status} withTextColors withIcons className="h6 mb-0" />
					)}
				</div>
			</Modal.Header>
			<Modal.Body className="py-0 h-75v overflow-auto">
				<DocumentData
					documentHash={documentId}
					textExists={false}
					draft={false}
					showStatus={false}
					onDataFetched={onDataFetched}
				/>
			</Modal.Body>
		</Modal>
	);
};

export default ViewDataDialog;
